import { AlertTriangle } from 'lucide-react';

interface PoolStatusBadgeProps {
  isActive: boolean;
}

const PoolStatusBadge = ({ isActive }: PoolStatusBadgeProps) => {
  if (isActive) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap bg-success/10 text-success">
        <span className="w-[7px] h-[7px] rounded-full bg-current" />
        Active
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap bg-grey4 text-grey10">
      <span className="w-[7px] h-[7px] rounded-full bg-current" />
      Inactive
    </span>
  );
};

export const OutOfRangeBadge = () => (
  <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap bg-dangerLight text-danger">
    <AlertTriangle className="w-[11px] h-[11px]" />
    Out of Range
  </span>
);

export const InRangeBadge = () => (
  <span className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap bg-success/10 text-success">
    <span className="w-[7px] h-[7px] rounded-full bg-current" />
    In Range
  </span>
);

export default PoolStatusBadge;
